const STORAGE_KEY = 'solutions:sidebar-expanded';

export const readSidebarExpanded = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const saveSidebarExpanded = (isExpanded: boolean): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(isExpanded));
  } catch {}
};
